import { entriesFactoryKeys } from './config';

const floorEntriesFactory = ({ porch }) => {
  return [{ key: 'porch', value: porch }];
};

const roomEntriesFactory = ({ porch, floor }) => {
  return [
    { key: 'porch', value: porch },
    { key: 'floor', value: floor },
  ];
};

export const createEntries = (type, props) => {
  switch (type) {
    case entriesFactoryKeys.floor:
      return floorEntriesFactory(props);

    case entriesFactoryKeys.room:
      return roomEntriesFactory(props);

    default:
      throw new Error(`Необрабаываемый тип в создании entries - ${type}`);
  }
};
